import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { errorMessage } from "../../../util/Helpers";
import { otpValidation } from "../_redux/authCrud";
import { shallowEqual, useSelector } from "react-redux";

const initialValues = {
  otp: "",
};

function OtpValidation(props) {
  const user = useSelector( ({auth}) => (auth.user), shallowEqual);
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);
  const OtpValidationSchema = Yup.object().shape({
    otp: Yup.string()
      .matches(/^[0-9]*$/, "Only numbers allowed")
      .length(6, "Six Digit")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
      trusted:Yup.string()
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: OtpValidationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
        otpValidation({...values})
        .then(({ data }) => {
          setIsRequested(true);
          const history = props.history
          /* Mauintain Usergroup Data */
          data = {...data, userGroup: user.userGroup};
          props.fulfillUser(data, history);
        })
        .catch(error => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(errorMessage(error));
        });
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/login" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 ">
            <h3 className="font-size-h1">Enter OTP </h3>
            <div className="text-muted font-weight-bold">
              {
                user?.otpMethod === "APP" ?
                "Get OTP from your Auth App"
                :
                "OTP sent to your account email (expire in 15 minutes)"
              }
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "otp"
                )}`}
                name="otp"
                {...formik.getFieldProps("otp")}
              />
              {formik.touched.otp && formik.errors.otp ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.otp}</div>
                </div>
              ) : null}
            </div>

            <div className="form-check form-check-inline pl-2 mb-5">
              <input 
                type="checkbox" 
                name="trusted" 
                {...formik.getFieldProps("trusted")} 
                className="form-check-input"
                id="trusted-checkbox"
              />
              <label 
                htmlFor="trusted-checkbox" 
                className="form-check-label pl-2">
                Add as trusted device (Login without OTP for 30 days)
              </label>
            </div>

            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                Submit
              </button>
              <Link to="/login">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  Cancel
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(OtpValidation));
